import { ToastType } from '@components/toast';
import { DocumentFormSetSearchRequestQuery, DocumentFormSetSearchResponse } from '@lio/api-types';
import { documentQueryKey } from '@services/document/keys';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { useSnackbar } from 'notistack';

const getSearchDocumentsQuery = (params: DocumentFormSetSearchRequestQuery) => {
  const { pageLimit, pageOffset, packageTypeId, sort } = params;
  const query = new URLSearchParams();
  if (pageLimit) {
    query.append('pageLimit', String(pageLimit));
  }
  if (pageOffset) {
    query.append('pageOffset', String(pageOffset));
  }
  if (packageTypeId) {
    query.append('packageTypeId', packageTypeId);
  }

  if (sort) {
    query.append('sort', sort);
  } else {
    query.append('sort', '-createdAt,-updatedAt');
  }

  return query.toString();
};

export const useSearchQuoteDocumentFormSet = (
  quoteId: string,
  params: DocumentFormSetSearchRequestQuery,
  enabled: boolean = true,
) => {
  const client = useClient();
  const query = `${getSearchDocumentsQuery(params)}`;

  const { enqueueSnackbar } = useSnackbar();
  const result = useQuery<DocumentFormSetSearchResponse, Error>({
    queryKey: documentQueryKey.searchDocumentFormSet(quoteId, params),
    queryFn: () => client.get(`quote/${quoteId}/document-form-set?${query}`).json<DocumentFormSetSearchResponse>(),
    gcTime: 15000,
    refetchOnWindowFocus: false,
    enabled,
    placeholderData: keepPreviousData,
  });
  if (result.isError) {
    enqueueSnackbar('No documents were  found', {
      variant: ToastType.Error,
      persist: true,
    });
  }

  return { ...result, documents: result.data };
};
